import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-callback',
  standalone: true,
  template: `<p data-testid="auth-callback-status">Signing in&hellip;</p>`,
})
export class CallbackComponent implements OnInit {
  private router = inject(Router);

  ngOnInit(): void {
    // The redirect return is processed once, app-wide, by initializeMsal
    // (provideAppInitializer in app.config.ts) BEFORE any route activates — it
    // consumes the response hash on the rail-matching MSAL instance and sets the
    // active account. This route only forwards the user on. Everyone goes to /inbox;
    // the role/cert guards are the single authority on where a VAR actually lands —
    // inboxAccessGuard sends an UNcertified VAR to /certification and lets a
    // certified VAR (and all staff) through. A second handleRedirectPromise() here was
    // a redundant redirect consumer (order-dependent foot-gun); removed (2026-08-10).
    this.router.navigate(['/inbox']);
  }
}
